module.exports = __webpack_public_path__ + "static/media/load.572a6f69.gif";